import _ from 'lodash';
import * as actionTypes from './actionTypes';

export const fetchUserData = () => ({
  type: actionTypes.FETCH_USER_DATA,
});

export const updateUserData = data => (dispatch) => {
  if (!_.isEmpty(data)) {
    dispatch({
      type: actionTypes.SET_USER_DATA,
      data,
    });
  }
};

export const addNotification = (type, message, options = {}) => ({
  type: actionTypes.ADD_NOTIFICATION,
  data: {
    type,
    message,
    options,
  },
});

export const removeNotification = id => ({
  type: actionTypes.REMOVE_NOTIFICATION,
  id,
});

export const setUserSettings = userSettings => ({
  type: actionTypes.SET_USER_SETTINGS,
  userSettings,
});

export const setSessionDataRestored = () => ({
  type: actionTypes.SESSION_DATA_RESTORED,
});

export const setSubscriptionsSettings = data => ({
  type: actionTypes.SET_SUBSCRIPTION_SETTINGS,
  data,
});
